import { AdvancedSearchConfig } from "../forms/advanced-search/advanced-search-fields-def";
import { ColumnFormatted } from "./general";

export const exhibitionColumns: ColumnFormatted[] = [
  { type: "string", key: "expositionsDescriptionNumeroExpo", visible: true },
  { type: "image", key: "expositionsDescriptionVignette", visible: true },
  { type: "string", key: "expositionsDescriptionAnnee", visible: true },
  { type: "string", key: "expositionsDescriptionTitre", visible: true },
  {
    type: "string",
    key: "expositionsDescriptionTitreDOrigine",
    visible: false,
  },
  { type: "string", key: "expositionsDescriptionDates", visible: true },
  { type: "string", key: "expositionsDescriptionLieu", visible: true },
  { type: "string", key: "expositionsDescriptionVille", visible: true },
  { type: "string", key: "expositionsDescriptionPays", visible: true },
  {
    type: "string",
    key: "expositionsDescriptionTexteSupplementaire",
    visible: false,
  },
  { type: "string", key: "expositionsDescriptionOrganisateur", visible: false },
  { type: "richtext", key: "expositionsDescriptionResume", visible: false },
  {
    type: "string",
    key: "expositionsDescriptionAutresArtistes",
    visible: false,
  },
  { type: "richtext", key: "expositionsDescriptionNotes", visible: false },
  {
    type: "boolean",
    key: "expositionsDescriptionExpositionItinerante",
    visible: false,
  },
  {
    type: "string",
    key: "expositionsDescriptionExpositionItinerante1EreExpo",
    visible: false,
  },
  {
    type: "boolean",
    key: "expositionsDescriptionExpositionDansMusee",
    visible: false,
  },
  {
    type: "boolean",
    key: "expositionsDescriptionExpositionCollective",
    visible: false,
  },
  {
    type: "boolean",
    key: "expositionsDescriptionAnneeIncertaine",
    visible: false,
  },
  {
    type: "boolean",
    key: "expositionsDescriptionTitreIncertain",
    visible: false,
  },
  {
    type: "boolean",
    key: "expositionsDescriptionDatesChoixInconnues",
    visible: false,
  },
  {
    type: "boolean",
    key: "expositionsDescriptionDatesChoixIncertaines",
    visible: false,
  },
  {
    type: "boolean",
    key: "expositionsDescriptionLieuIncertain",
    visible: false,
  },
  {
    type: "boolean",
    key: "expositionsDescriptionCityIncertain",
    visible: false,
  },
  {
    type: "boolean",
    key: "expositionsDescriptionCountryIncertain",
    visible: false,
  },
  {
    type: "boolean",
    key: "expositionsDescriptionExpositionPersonnelle",
    visible: false,
  },
  { type: "status", key: "expositionsPublicationStatus", visible: true },
  { type: "string", key: "sources", visible: false },
];

export const exhibitionColumnsVisibility = exhibitionColumns.reduce(
  (acc, column) => ({
    ...acc,
    [column.key]: column.visible ?? true,
  }),
  {} as Record<string, boolean>,
);

export const exhibitionAdvancedSearchConfig: AdvancedSearchConfig = [
  {
    type: "group",
    label: "exhibitionDescription",
    fields: [
      { type: "string", key: "expositionsDescriptionNumeroExpo" },
      { type: "string", key: "expositionsDescriptionAnnee" },
      { type: "boolean", key: "expositionsDescriptionAnneeIncertaine" },
      { type: "string", key: "expositionsDescriptionTitre" },
      { type: "boolean", key: "expositionsDescriptionTitreIncertain" },
      { type: "string", key: "expositionsDescriptionTitreDOrigine" },
      { type: "string", key: "expositionsDescriptionDates" },
      { type: "boolean", key: "expositionsDescriptionDatesChoixInconnues" },
      { type: "boolean", key: "expositionsDescriptionDatesChoixIncertaines" },
      { type: "string", key: "expositionsDescriptionLieu" },
      { type: "boolean", key: "expositionsDescriptionLieuIncertain" },
      { type: "string", key: "expositionsDescriptionVille" },
      { type: "boolean", key: "expositionsDescriptionCityIncertain" },
      { type: "string", key: "expositionsDescriptionPays" },
      { type: "boolean", key: "expositionsDescriptionCountryIncertain" },
      { type: "string", key: "expositionsDescriptionTexteSupplementaire" },
      { type: "string", key: "expositionsDescriptionOrganisateur" },
      { type: "string", key: "expositionsDescriptionResume" },
      { type: "boolean", key: "expositionsDescriptionExpositionItinerante" },
      { type: "boolean", key: "expositionsDescriptionExpositionDansMusee" },
      { type: "boolean", key: "expositionsDescriptionExpositionCollective" },
      { type: "boolean", key: "expositionsDescriptionExpositionPersonnelle" },
    ],
  },
  {
    type: "group",
    label: "exhibitionAutresArtistes",
    fields: [
      { type: "string", key: "expositionsDescriptionAutresArtistes" },
      {
        type: "string",
        key: "LooselyRelatedAuthor.some.fallbackLabel",
        label: "autresArtistesModaleNomLabel",
      },
    ],
  },
  {
    type: "group",
    label: "exhibitionNotes",
    fields: [{ type: "string", key: "expositionsDescriptionNotes" }],
  },
  {
    type: "group",
    label: "exhibitionSources",
    fields: [{ type: "string", key: "sources" }],
  },
];
